export const DAYS ='days';
export const POSTS = 'posts';